export default __webpack_public_path__ + "static/media/file-searching.0eaf4c28.gif";